import styled from "@emotion/styled"
import { styled as MIStyled } from "@mui/material/styles"

import Link from "next/link"
import { useRef, useState } from "react"
import { FilePdfIcon, FormHelperErrorIcon, NewText } from "ui"
import { sharedColors } from "ui/theme/colors"

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 16px;
  background-color: white;
  border-radius: 16px;
  border-width: 1px;
  display: flex;
  flex-direction: column;
  ${(props) => props.theme.breakpoints.up("md")} {
  }
`

const StyledErrorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;

  svg {
    margin-right: 4px;
  }
`

const StyledButton = styled.button`
  background-color: white;
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border-radius: 200px;
  border: 2px solid #000;
  margin-left: auto;
  min-width: 121px;
  margin-top: auto;
  position: relative;
  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
`
const VisuallyHiddenInput = MIStyled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
})

type Props = {
  target: string
  title: string
  setFormFiles: any
  isValid: any
  error: boolean
  upload: string
  errorMessage?: string
}

function FileSelectCard({
  target,
  title,
  setFormFiles,
  isValid,
  error,
  upload,
  errorMessage,
}: Props) {
  const fileInputRef = useRef<any>()
  const [localFile, setLoaclFile] = useState<File | null>(null)
  const errorId = `${target}-error`
  const showError = error && !localFile && errorMessage

  const handleInputClick = (e: any) => {
    e.preventDefault()
    fileInputRef.current.click()
  }
  const handleInputChange = (e: any) => {
    const selectedFile = e.target.files[0]
    if (selectedFile) {
      setFormFiles((prev: any) => ({
        ...prev,
        [target]: selectedFile,
      }))
      setLoaclFile(selectedFile)
    }
  }
  return (
    <StyledContainer
      style={{
        border:
          (error && !localFile) || !localFile?.name?.includes(".pdf")
            ? "1px solid #C92418"
            : "none",
      }}
    >
      <NewText
        desktopFontSize={16}
        desktopFontWeight="400"
        desktopLineHeight="23px"
        mobileFontSize={14}
        mobileFontWeight="400"
        mobileLineHeight={"20px"}
        component="h1"
        color={"black"}
        style={{ maxWidth: "560px", marginBlockEnd: "16px" }}
      >
        {title}
      </NewText>
      {isValid(target) && localFile && (
        <StyledLink href={URL.createObjectURL(localFile)} target="_blank">
          <FilePdfIcon />
          <NewText
            desktopFontSize={16}
            desktopFontWeight="400"
            desktopLineHeight="23px"
            mobileFontSize={14}
            mobileFontWeight="400"
            mobileLineHeight={"20px"}
            component="p"
            color={sharedColors.propBlue}
            marginRight="4px"
            maxWidth={"80%"}
          >
            {localFile?.name}
          </NewText>
        </StyledLink>
      )}
      <StyledButton onClick={handleInputClick}>
        <NewText
          desktopFontSize={16}
          desktopFontWeight="600"
          desktopLineHeight="23px"
          mobileFontSize={14}
          mobileFontWeight="600"
          mobileLineHeight={"20px"}
          component="p"
          color={sharedColors.black}
          marginRight="4px"
          maxWidth={"80%"}
        >
          {upload}
        </NewText>
      </StyledButton>
      <VisuallyHiddenInput
        type="file"
        ref={fileInputRef}
        onChange={(e) => handleInputChange(e)}
        accept="application/pdf"
        aria-describedby={showError ? errorId : undefined}
      />
      {showError && (
        <StyledErrorContainer id={errorId} role="alert">
          <FormHelperErrorIcon />
          <p
            style={{
              margin: 0,
              textAlign: "right",
              color: "#C92418",
              marginRight: "4px",
              fontSize: "12px",
            }}
          >
            {errorMessage}
          </p>
        </StyledErrorContainer>
      )}
    </StyledContainer>
  )
}

export default FileSelectCard
